import React, { useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enUS } from "date-fns/locale";
import OutsideClickHandler from "react-outside-click-handler";
const CustomCalendar = ({ value, setShow, onChange }) => {
  const [state, setState] = useState([
    {
      startDate: new Date(value?.fromPeriod) || new Date(),
      endDate: new Date(value?.toPeriod) || new Date(),
      key: "selection",
    },
  ]);
  return (
    <div
      role="document"
      tabIndex={0}
      data-v-c5353408
      className="v-dialog__content v-dialog__content--active"
      style={{ "z-index": "202" }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{
          "-webkit-transform-origin": "center center",
          "-ms-transform-origin": "center center",
          "transform-origin": "center center",
          "max-width": "fit-content",
        }}
      >
        <OutsideClickHandler onOutsideClick={() => setShow(false)}>
          {" "}
          <div
            data-v-c5353408
            className="dialog-card v-card v-sheet theme--light"
          >
            <DateRange
              editableDateInputs={true}
              onChange={(item) => {
                setState([item.selection]);
                onChange(item.selection);
              }}
              moveRangeOnFirstSelection={false}
              ranges={state}
              locale={enUS}
              maxDate={new Date()}
            />
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default CustomCalendar;
